import { Reveal } from "./Reveal";
import HeaderBg, { STUDIO } from "./HeaderBg";

export default function Biography({ chapters = [] }) {
  return (
    <section id="biography" className="relative bg-obsidian py-24 md:py-40" data-testid="biography-section">
      <HeaderBg image={STUDIO.mixer} />
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="mb-20 md:mb-32 max-w-3xl">
          <p className="overline text-gold mb-6">The Origin Story</p>
          <h2 className="headline text-5xl md:text-7xl text-white">
            One <span className="text-gold">producer</span>.
            <br />
            <span className="font-editorial italic normal-case tracking-normal text-white/80 lowercase">a whole new grammar of sound.</span>
          </h2>
        </Reveal>

        <div className="flex flex-col gap-24 md:gap-0">
          {chapters.map((c, i) => (
            <div
              key={c.id}
              className={`relative md:grid md:grid-cols-12 md:gap-10 md:py-24 border-t border-white/10 ${
                c.num === "01" ? "bg-[#0d0d0d] overflow-hidden rounded-lg px-6 md:px-10 py-16" : ""
              }`}
              data-testid={`bio-chapter-${c.num}`}
            >
              {c.num === "01" && (
                <div
                  className="absolute inset-0 pointer-events-none"
                  aria-hidden
                  style={{ background: "radial-gradient(circle at 80% 20%, rgba(79, 176, 74,0.12), transparent 55%)" }}
                />
              )}
              {/* Sticky number */}
              <div className="relative z-10 md:col-span-4">
                <div className="md:sticky md:top-28">
                  <span className="font-display text-[26vw] md:text-[11rem] leading-none text-white/[0.06] font-700">
                    {c.num}
                  </span>
                </div>
              </div>

              {/* Narrative */}
              <div className="relative z-10 md:col-span-8 md:pt-6">
                <Reveal>
                  <p className="overline text-gold mb-4">{c.subtitle}</p>
                  <h3 className="font-editorial italic text-3xl md:text-5xl text-white mb-8">{c.title}</h3>
                  {c.image && (
                    <figure className="mb-8">
                      <div className="overflow-hidden">
                        <img
                          src={c.image}
                          alt={c.title}
                          className="w-full h-[280px] md:h-[440px] object-cover grayscale contrast-110 transition-transform duration-700 hover:scale-[1.02]"
                        />
                      </div>
                      {c.num === "01" && (
                        <figcaption className="mt-3 flex items-center gap-3 font-display uppercase tracking-[0.2em] text-[0.66rem] text-white/45" data-testid="norfolk-caption">
                          <span className="h-px w-8 bg-gold" />
                          757 Roots, Norfolk, Virginia, where it all began
                        </figcaption>
                      )}
                    </figure>
                  )}
                  <p className="text-white/65 text-lg md:text-xl leading-relaxed font-body max-w-2xl">{c.body}</p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
